import { render, staticRenderFns } from "./OfficalInfoModal.vue?vue&type=template&id=244d1949&"
import script from "./OfficalInfoModal.vue?vue&type=script&lang=js&"
export * from "./OfficalInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./OfficalInfoModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports